import { c as _c } from "react/compiler-runtime";
import { Card, CardContent } from '@achra/ui/card';
import { Skeleton } from '@achra/ui/skeleton';
function SubmitRequestFormSkeleton() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-col gap-2"><Skeleton className="h-4 w-16" /><Skeleton className="h-9 w-full rounded-md" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-col gap-2"><Skeleton className="h-4 w-24" /><Skeleton className="h-9 w-full rounded-md" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <fieldset className="flex flex-col gap-4">{t0}{t1}<div className="flex flex-col gap-2"><Skeleton className="h-4 w-16" /><Skeleton className="h-9 w-full rounded-md" /><Skeleton className="h-4 w-full max-w-64" /></div></fieldset>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Card className="mx-auto w-full max-w-218.5 border-none py-0! lg:mx-0 lg:max-w-none"><CardContent className="p-3 lg:p-6"><div className="flex flex-col gap-6">{t2}<div className="flex flex-col gap-4"><Skeleton className="h-10 w-full rounded-md" /></div></div></CardContent></Card>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
export { SubmitRequestFormSkeleton };